import { useEvent, useState } from 'hooks'
import $ from 'jquery'
import { debounce } from 'utils'

import { getFormComponents } from './selector'

type State = {
	languageSelect: HTMLSelectElement | null
	htmlTextArea: HTMLInputElement | null
}

export const Form = (() => {
	const { state, setState } = useState<State>()

	const initSelect = () => {
		const { languageSelect, htmlTextArea } = state

		if (languageSelect === null || htmlTextArea === null) {
			return
		}

		const urlString = languageSelect.getAttribute('data-url')

		if (urlString === null) {
			return
		}

		const change = useEvent(languageSelect, 'change')
		change.register(
			debounce(() => {
				const targetUrl = new URL(urlString, window.location.origin)

				const args = targetUrl.pathname.split('/')

				if (args.length > 0) {
					if (Number.isNaN(Number.parseInt(args[args.length - 1], 10))) {
						args.push(languageSelect.value)
					} else {
						args[args.length - 1] = languageSelect.value
					}
				}

				targetUrl.pathname = args.join('/')

				// @ts-ignore
				$.nette.ajax({
					type: 'POST',
					url: targetUrl,
				})
			}),
		)
	}

	const init = () => {
		setState({ ...getFormComponents() })

		initSelect()
	}

	return {
		init,
	}
})()
